import { Link } from "react-router-dom";
import { NerdStackFooter } from "../components/NerdStackFooter.jsx";
import BackArrow from "../components/BackArrow.jsx";
import { gradientFor } from "../components/toolGradients.js";
import { ToolPageBadge } from "../components/ToolPageBadge.jsx";

// NerdMath accent = teal (per locked icon-derived rule: in-app accent =
// icon gradient START hue). Ma badge gradient teal -> violet #7C3AED.
export const MATH_ACCENT = "#2DD4BF";
export const VIOLET = "#7C3AED";

export function MathShell({ title, children, back = "/math" }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0A0B14",
        color: "#E8E9F3",
        display: "flex",
        flexDirection: "column",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "16px 18px",
          borderBottom: "1px solid #1C1E2E",
          position: "sticky",
          top: 0,
          background: "#0A0B14",
          zIndex: 10,
        }}
      >
        <BackArrow to={back} from={MATH_ACCENT} toColor={gradientFor(title, "/math/x").from} />
        <ToolPageBadge name={title} family="math" accent={MATH_ACCENT} />
        <h1 style={{ fontSize: 17, fontWeight: 600, margin: 0 }}>{title}</h1>
      </header>
      <main style={{ flex: 1, padding: "clamp(20px, 3vw, 36px) clamp(18px, 4vw, 40px)", maxWidth: "min(900px, 92vw)", width: "100%", margin: "0 auto" }}>
        {children}
      </main>
      <footer style={{ padding: "14px 18px", borderTop: "1px solid #1C1E2E" }}>
        <NerdStackFooter variant="tool" family="math" />
      </footer>
    </div>
  );
}

export function Field({ label, ...props }) {
  return (
    <label style={{ display: "block", marginBottom: 14 }}>
      <span style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>{label}</span>
      <input
        {...props}
        style={{
          width: "100%",
          background: "#13141F",
          border: "1px solid #262839",
          borderRadius: 10,
          color: "#E8E9F3",
          fontSize: 16,
          padding: "12px 14px",
          outline: "none",
          boxSizing: "border-box",
        }}
      />
    </label>
  );
}

export function ResultCard({ children }) {
  return (
    <div
      style={{
        marginTop: 18,
        background: "#13141F",
        border: `1px solid ${MATH_ACCENT}33`,
        borderRadius: 12,
        padding: "16px 18px",
      }}
    >
      {children}
    </div>
  );
}

